<template>
  <div>

    <div v-if="debug_show_page_name==true" style="color:green;">log-history-modal</div>
    <modal class="change_history-modal" width="95%" height="90%"  content_height="90%" body_height="85%" :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><strong>更新履歴</strong></center>
        </h4>
      </div>
      <div  class="modal-body change_history-modal-body " style="height: 95%;padding: 0px 15px; overflow-x: auto;" >
        <ag-grid-vue style="min-width:100px;width: 100%; height: 200px" class="ag-blue" :gridOptions="gridOptions" :rowData="rowData"></ag-grid-vue>
        <div v-if="showDetails">
          <div class="row">
            <div class="col-xs-6" >
              <table style="margin:auto;margin-top:30px;width:100%" class="hist_td">
                <tr>
                  <th class="hist_td">項目</th>
                  <th class="hist_td">古いデータ</th>
                  <th class="hist_td">新しいデータ</th>
                </tr>
                <tr v-for="d in dataChangesA" :key="d.id">
                  <th class="hist_td">{{d.label}}</th>
                  <td class="hist_td">{{d.o}}</td>
                  <td v-if="d.n.length > 0" style="color:red" class="hist_td">{{d.n}}</td>
                  <td v-else  class="hist_td">{{d.o}}</td>
                </tr>
              </table>
              <table v-if="bulkTorokuNumber != null" style="margin:auto;margin-top:20px;width:100%" class="hist_td">
                <tr >
                  <th class="hist_td" style="width:33%;">一括編集No</th>
                  <td class="hist_td" colspan="2">
                    <router-link
                      :to="'/approval_history/toroku_filter/' + bulkTorokuNumber"
                      type="button"
                      style="margin: -10px -10px;"
                      class="btn btn-plain ">{{ bulkTorokuNumber }}</router-link>
                  </td>
                </tr>
              </table>
            </div>
            <div class="col-xs-6" >
              <table v-if=" Array.isArray(dataChangesB)" style="margin:auto;margin-top:30px;width:100%" class="hist_td">
                <tr>
                  <th class="hist_td">項目</th>
                  <th class="hist_td">古いデータ</th>
                  <th class="hist_td">新しいデータ</th>
                </tr>
                <tr v-for="d in dataChangesB" :key="d.id">
                  <th class="hist_td">{{d.label}}</th>
                  <td class="hist_td">{{d.o}}</td>
                  <td v-if="d.n.length > 0" style="color:red" class="hist_td">{{d.n}}</td>
                  <td v-else  class="hist_td">{{d.o}}</td>
                </tr>
              </table>
            </div>
          </div>

        </div>

      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <div style="float:left">
          {{changeTime}}
        </div>
        <button type="button" class="btn btn-default " @click="closed('no')">戻る</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus';
import { utils } from '@/libs/utils';
var vm = this;

import modal from './local-modal';
import output_config from '../../rules/output_config.js';
import { AgGridVue } from 'ag-grid-vue';
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { fields, filed_types } from '@/rules/fields_change_history';
import { fields as fields_certificate } from '@/rules/fields_certificate';
import { fields as fields_certificate_software } from '@/rules/fields_certificate_software';
import { fields as fields_device_embedded_information } from '@/rules/fields_device_embedded_information';
import { fields as fields_approval_history } from '@/rules/fields_approval_history';
import moment from 'moment';

Vue.component('modal', modal);
import _ from 'lodash';
import debug from 'debug';
import constants from '../../rules/constants';
var debug_log_history = debug('esma:change_history');
export default {
   mixins:[
        mixinPageCommon,mixinDatasource
  ],
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      show_modal: false,
      selected_data :false,
      row_data:[],
      api_name:"change_history",
      search_timeout : false,
      search_model:"",
      show_details:false,
      data_changes:[],

      state_current_row:"current_row3",
      state_is_editing_new:"is_editing_new3",
      change_time:null,
      use_predefined_list:false,
      bulk_toroku_number:null
    };
  },
  computed: {
    bulkTorokuNumber:{
      get(){
        return this.bulk_toroku_number;
      },
      set(v){
        this.bulk_toroku_number = v;
      }
    },
    changeTime:{
      get(){
        return this.change_time;
      },
      set(v){
        this.change_time = v;
      }
    },
    dataChangesA(){
      if(this.use_predefined_list == constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION){
        return this.deviceInformationFields("a")
      }
      var c = parseInt(this.dataChanges.length / 2) + 1
      return  _.chunk(this.dataChanges,c)[0]
    },
    dataChangesB(){
      if(this.use_predefined_list == constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION){
        return this.deviceInformationFields("b")
      }
      var c = parseInt(this.dataChanges.length / 2) + 1
      return  _.chunk(this.dataChanges,c)[1]
    },


    dataChanges:{
      get(){
        return this.data_changes;
      },
      set(v){
        this.data_changes = v;
      }
    },
    showDetails:{
      get(){
        return this.show_details;
      },
      set(v){
        this.show_details = v;
      }
    },
    searchModel:{
      get(){
        return this.search_model;
      },
      set(v){
        this.search_model = v;
      }
    },
    rowData:{
      get(){
        return this.row_data;
      },
      set(v){
        this.row_data = v;
      }
    },
    selectedData:{
      get(){
        return this.selected_data;
      },
      set(v){
        this.selected_data = v;
      }
    },

    pageID() {
      return this.$props.pageid;
    },
    showModal:{
      get(){
        return this.show_modal;
      },
      set(v){
        this.show_modal = v;
      }
    },
    tabFieldList() {
      return [
        //this.form_fields = 'seq_id,change_time,user_id,fk_tab,fk_id,data_id,mode,description,old_data,new_data';
        utils.extend(fields.change_time, {type:filed_types.CURRENT_TIME}),
        utils.extend(fields.user_label, {}),
        utils.extend(fields.fk_tab, {}),
        utils.extend(fields.data_id, {tab_label:this.$props.id_label||"ID"}),
        utils.extend(fields.mode, {}),
        utils.extend(fields.description, {})
      ];
    }
  },
  methods: {
        deviceInformationFields(side){
          var list_a = ["device_control_number","approval_status","status","registration_date","last_update_date","computer_name","virtual_environment","virtual_base_unit","company","equipment_in_charge_department","equipment_in_charge_team","equipment_in_charge_classification","equipment_in_charge_system","equipment_in_charge_system_it"];
          var list_b = ["leasing_or_rental","manufacture_name","model_name","equipment_classification","cpu_count","installation_department","installation_team","installation_base","floor","user_name","management_person_name","remarks"];
          var ret = []
          if(side == "a"){
            list_a.forEach((k)=>{
              var d = _.find(this.dataChanges,(i)=>{ return i.id == k}) || false
              if(d){
                ret.push(d)
              }
            })
          }
          if(side == "b"){
            list_b.forEach((k)=>{
              var d = _.find(this.dataChanges,(i)=>{ return i.id == k}) || false
              if(d){
                ret.push(d)
              }
            })
            this.dataChanges.forEach(e=>{
              if(list_a.indexOf(e.id) < 0 && list_b.indexOf(e.id) < 0){
                  ret.push(e)
              }
            })
          }
          return ret;
    },
   onRowSelected( data) {
      console.log('onRowSelected', data.node.data);
      this.changeTime = moment(data.node.data.change_time).format("YYYY/MM/DD HH:mm:ss");
      this.$ajax.post("/"+this.api_name+"/get/" + data.node.data.seq_id, {}, (err, result) => {
        this.showDetails = true
        this.use_predefined_list = false
        var use_fields = {}
        if(result.data.fk_tab == constants.TABLE_ID.CERTIFICATE){
          use_fields = fields_certificate;
        }else if(result.data.fk_tab == constants.TABLE_ID.CERTIFICATE_SOFTWARE){
          use_fields = fields_certificate_software;
        }else if(result.data.fk_tab == constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION){
          this.use_predefined_list = constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION
          use_fields = fields_device_embedded_information
        }else if(result.data.fk_tab == constants.TABLE_ID.APPLICATION_FLOW_CERTIFICATE_SOFTWARE || result.data.fk_tab == constants.TABLE_ID.APPLICATION_FLOW_DEVICE_EMBEDDED_INFORMATION){
          use_fields = fields_approval_history
        }else{
        }
        this.bulkTorokuNumber = null;
        if(result.data.bulk_toroku_number && result.data.bulk_toroku_number.length > 0){
          this.bulkTorokuNumber = result.data.bulk_toroku_number
        }
        var old_data = JSON.parse(result.data.old_data);
        var new_data = JSON.parse(result.data.new_data);
        var all_keys = Object.keys(old_data);
        Object.keys(new_data).forEach(k=>{
          if(all_keys.indexOf(k) < 0){
            all_keys.push(k)
          }
        })
        this.dataChanges = []
        all_keys.forEach(k=>{
          if(k.indexOf("seq_id") < 0 && use_fields && use_fields[k]){
            var obj = {
              id:k,
              label:(use_fields && use_fields[k])?use_fields[k].label:k,
              o :(old_data[k] || "") + "",
              n :(new_data[k] || "") + "",
            }
            if((k == "last_update_date" || k == "registration_date" ) && (obj.n.length > 0 || obj.o.length > 0)){
              obj.n = moment(obj.n).format("YYYY/MM/DD")
              obj.o = moment(obj.o).format("YYYY/MM/DD")
              if(obj.o =="Invalid date"){
                obj.o = ""
              }
              if(obj.n =="Invalid date"){
                obj.n = ""
              }
              if(obj.o == obj.n){
                obj.n = "";
              }
            }
            if( obj.o.length > 0 || obj.n.length > 0){
              if(k != "status_at_approve_request" && k != "approval_status_flag"){
                this.dataChanges.push(obj)
              }
            }
          }
        })
      });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:false,show_checkbox:false})
    },
    onSearch(txt,data){
      // clearTimeout(this.search_timeout);
      // this.search_timeout = setTimeout(()=>{
        var fk_id = data.fk_id;
        var fk_tab = data.fk_tab;
        var obj = {
            "1": {block: "1", field: "fk_id", value: ""+fk_id, ct: "v", ca: false, t: "input",exact_value:true},
            "2":{block: "2", field: "fk_tab", value: ""+fk_tab, ct: "v", ca: false, t: "input",exact_value:true},
            "3": false,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          }
          // if(fk_tab == 9){
          //   obj["3"] = {block: "3", field: "fk_tab", value: ""+8, ct: "v", ca: false, t: "input",exact_value:true}
          //   obj.j2 = "OR"
          //   obj.b3_disabled = false
          // }
        this.searchControlChangedDatasource(
          obj
        )
      // },(txt =="")?0:300)
    },
    cancelCurrentSelection() {
      //Dummy, needed due mixinDataSource
    },
    updateValue(vm, ev, mode, cb=()=>{}){
      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.number_cert;
      }
    },
    onShow(data) {
      this.searchModel = "";
      this.selectedData = false;
        this.$notify({clean: true});
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
      this.onSearch("",data);
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },500)
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },1000)
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },3000)
    },
    showModalWindow(data) {
      debug_log_history("showModalWindow");
      this.onShow(data);
      this.showModal = true;
    },
    closed(mode) {
      this.showModal = false;
      this.$emit('done', mode);
    },

  },

   beforeMount() {
    // this.$store.state.current_row = {};

    //AG Grid options
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource({load_only_with_filter:true});
  },
  mounted() {
    debug_log_history('On mounted');
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
    props: {
    tag: { type: String, default: 'showLogHistory' },
    pageid: { type: String },
    fk_tab: { type: String },
    fk_id: { type: String },
    id_label: { type: String },
  },
};

</script>
<style scoped>

.info_div {
  width: 32%;
  float: left;
}
.hist_td {
  border:1px solid #ccc;
  padding:2px 10px;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// change-history-modal.vue?20b98e44